enum SettingsTypes {
    GET_LINES = 'GET_LINES',
    GET_LINES_LOADING = 'GET_LINES_LOADING',

    GET_GLOBAL_LINE = 'GET_GLOBAL_LINE',
    UPDATE_GLOBAL_LINE = 'UPDATE_GLOBAL_LINE',
    GET_GLOBAL_LINE_LOADING = 'GET_GLOBAL_LINE_LOADING',
    GET_GLOBAL_LINE_ERROR = 'GET_GLOBAL_LINE_ERROR', // Global line not found - 404 error

    UPDATE_LINES = 'UPDATE_LINES',
    UPDATE_LINES_LOADING = 'UPDATE_LINES_LOADING',
    SET_FILTERED_LINES = 'SET_FILTERED_LINES',
    GET_REPORTS = 'GET_REPORTS',
    GET_REPORTS_LOADING = 'GET_REPORTS_LOADING',
    GENERATE_REPORTS_LOADING = 'GENERATE_REPORTS_LOADING',

    GET_USERS = 'GET_USERS',
    GET_USERS_LOADING = 'GET_USERS_LOADING',
    GET_USERS_ERROR = 'GET_USERS_ERROR',
    GET_ROUTING_PROFILES = 'GET_ROUTING_PROFILES',
    GET_SECURITY_GROUPS = 'GET_SECURITY_GROUPS',
    GET_USER_HIERARCHY = 'GET_USER_HIERARCHY',
    GET_HIERARCHY_GROUPS = 'GET_HIERARCHY_GROUPS',
    GET_QUEUES = 'GET_QUEUES',
    GET_ENABLED_QUEUES = 'GET_ENABLED_QUEUES',
    GET_EMAIL_TEMPLATES = 'GET_EMAIL_TEMPLATES',
    GET_ALLOWED_ATTACHMENT_TYPES = 'GET_ALLOWED_ATTACHMENT_TYPES',
    GET_CONTACT_FLOWS = 'GET_CONTACT_FLOWS',
    GET_PERMISSIONS = 'GET_PERMISSIONS',
    GET_PERMISSIONS_ERROR = 'GET_PERMISSIONS_ERROR',
    GET_FEATURE_LIST = 'GET_FEATURE_LIST',

    DELETING_USER = 'DELETING_USER', // Show confirmation for deleting THIS user
    DELETE_USER = 'DELETE_USER', // do the DELETE and reflect this in state,
    DELETE_USER_LOADING = 'DELETE_USER_LOADING', // Delete in progress,
    DELETE_USER_ERROR = 'DELETE_USER_ERROR', // Error message back from endpoint

    DISABLING_USER = 'DISABLING_USER',
    DISABLE_USER = 'DISABLE_USER',
    DISABLE_USER_LOADING = 'DISABLE_USER_LOADING',
    DISABLE_USER_ERROR = 'DISABLE_USER_ERROR',

    ENABLING_USER = 'ENABLING_USER',
    ENABLE_USER = 'ENABLE_USER',
    ENABLE_USER_LOADING = 'ENABLE_USER_LOADING',
    ENABLE_USER_ERROR = 'ENABLE_USER_ERROR',

    ADD_USER = 'ADD_USER', // Do the POST and refresh user list
    ADDING_USER_LOADING = 'ADDING_USER_LOADING', // Whether the post is going on
    ADDING_USER = 'ADDING_USER', // whether we should show the form or not
    ADD_USER_ERROR = 'SETTINGS_ADD_USER_ERROR', // Error message back from endpoint

    EDIT_USER = 'EDIT_USER', // Do the PUT agent and refresh user list
    EDITING_USER = 'EDITING_USER', // The user we are currently editing
    EDIT_USER_REFRESH = 'EDIT_USER_REFRESH', // Get refresh the user for editing just in case its changes
    EDIT_USER_ERROR = 'EDIT_USER_ERROR', // Error putting user
    EDITING_USER_LOADING = 'EDITING_USER_LOADING', // If the PUT is currently in progress
    SET_RINGING_DEVICE = 'SET_RINGING_DEVICE',

    GET_COGNITO_CONFIG = 'GET_COGNITO_CONFIG',
    GET_SETTINGS_LOADING = 'GET_SETTINGS_LOADING',
    GET_SETTINGS = 'GET_SETTINGS',
    EDIT_SETTINGS = 'EDIT_SETTINGS',
    EDIT_SETTINGS_LOADING = 'EDIT_SETTINGS_LOADING',

    GET_AUDIT_LOGS_LOADING = 'GET_AUDIT_LOGS_LOADING',
    GET_AUDIT_LOGS = 'GET_AUDIT_LOGS',
    GET_AUDIT_LOGS_ERROR = 'GET_AUDIT_LOGS_ERROR',

    GET_SETTING_NAMES_FOR_AUDIT_LOGS_LOADING = 'GET_SETTING_NAMES_FOR_AUDIT_LOGS_LOADING',
    GET_SETTING_NAMES_FOR_AUDIT_LOGS = 'GET_SETTING_NAMES_FOR_AUDIT_LOGS',
    GET_SETTING_NAMES_FOR_AUDIT_LOGS_ERROR = 'GET_SETTING_NAMES_FOR_AUDIT_LOGS_ERROR',

    GET_USERS_LIST_FOR_AUDIT_LOGS_LOADING = 'GET_USERS_LIST_FOR_AUDIT_LOGS_LOADING',
    GET_USERS_LIST_FOR_AUDIT_LOGS = 'GET_USERS_LIST_FOR_AUDIT_LOGS',
    GET_USERS_LIST_FOR_AUDIT_LOGS_ERROR = 'GET_USERS_LIST_FOR_AUDIT_LOGS_ERROR',
    ENABLE_WEBHID = 'ENABLE_WEBHID',
    DISABLE_WEBHID = 'DISABLE_WEBHID',

    GET_CALLBACK_QUEUES_LOADING = 'GET_CALLBACK_QUEUES_LOADING',
    GET_CALLBACK_QUEUES = 'GET_CALLBACK_QUEUES',
    GET_CALLBACK_QUEUES_ERROR = 'GET_CALLBACK_QUEUES_ERROR',

    UPDATE_CALLBACK_QUEUE_LOADING = 'UPDATE_CALLBACK_QUEUE_LOADING',
    UPDATE_CALLBACK_QUEUE = 'UPDATE_CALLBACK_QUEUE',
    UPDATE_CALLBACK_QUEUE_ERROR = 'UPDATE_CALLBACK_QUEUE_ERROR',
}

export default SettingsTypes;
